import PropTypes from "prop-types";
import React from "react";

// import album from "./album.svg";
import close_white from "./close_white.svg";
import filter from "./filter.svg";
import inventory_2 from "./inventory_2.svg";
import menu from "./menu.svg";
import search from "./search.svg";
import sort from "./sort.svg";

const icons = new Map();
// icons.set("album", album);
icons.set("close_white", close_white);
icons.set("filter", filter);
icons.set("inventory_2", inventory_2);
icons.set("menu", menu);
icons.set("search", search);
icons.set("sort", sort);

const Icon = ({
  className,
  icon,
  onClick,
}) => {

  return (
    <img
      className={className}
      onClick={onClick}
      src={icons.get(icon)}
      alt=""
    />
  );
};

export default Icon;

Icon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
};
